export const apiKey = process.env.REACT_APP_ABLY_API_KEY;
export const chatChannelName = 'driver-pharmacist-chat-channel'

export const currentDeliveryStartChannel = process.env.REACT_APP_CURRENT_DELVIERY_START;
export const currentDeliveryEndChannel = process.env.REACT_APP_CURRENT_DELIVERY_END;
export const deliveryDriverDeliveredDispense = process.env.REACT_APP_DELIVERY_DRIVER_DELIVERED_DISPENSE;

export const oatPharmacyInspectionMode = process.env.REACT_APP_OAT_PHARMACY_INSPECTION_MODE;

export const oat_driver_login = 'oat-driver-login';
export const oat_driver_passcode_verify = 'oat-driver-passcode-verify';
export const driver_pharmacy = 'driver/driver-pharmacy';

export const change_password = 'driver/setting/change-password';
export const change_passcode = 'driver/setting/change-passcode';
export const driver_logout = 'driver/logout';

export const driver_get_route_list = 'driver/get-route-list';
export const driver_route_options = 'driver/route-options';
export const driver_get_patients = 'driver/get-patients';
export const driver_get_delivered_patients = 'driver/deliverd-patient-list';
export const driver_select_routes = 'driver/select-routes';
export const driver_active_routes = 'driver/active-routes';
export const driver_logout_readiness = 'driver/logout-readiness';
export const driver_drop_routes = 'driver/drop-routes';
export const driver_route_interruptions = 'driver/route-interruptions';
export const driver_route_interruptions_heartbeat = 'driver/route-interruptions/heartbeat';
export const driver_handover_targets = 'driver/handover-targets';
export const driver_handover_patients = 'driver/handover-patients';
export const driver_handover_untempered = 'driver/handover-untempered';
export const driver_handover_requests = 'driver/handover-requests';
export const driver_patient_spotted = 'driver/patient-spotted';
export const driver_live_location = 'driver/live-location';
export const driver_live_location_deny = 'driver/live-location/deny';

export const driver_patient_search = 'driver/patient-search';
export const driver_get_pharmacist = 'driver/get-pharmacist-with-route';
export const driver_patient_delivery = 'driver/patient-delivery';

export const driver_get_all_pending_list = 'driver/get-all-pending-list';
export const driver_check_partial_delivered = 'driver/check-partial-delivered';
export const driver_confirm_delivery = 'driver/confirm-delivery';
export const update_profile = 'driver/setting/update-driver-profile';
export const upload_identity = 'driver/setting/update-driver-documents';
export const driver_identity_document = (documentType) => `driver/setting/driver-documents/${documentType}`;
export const get_driver_profile_details = 'driver/setting/get-driver-profile';

export const driver_driver_final_missed = 'driver/driver-final-missed';
export const driver_driver_today_missed = 'driver/driver-today-missed';
export const driver_update_delivery_status = 'driver/update-delivery-status';

export const driver_delivered_route_list = 'driver/driver-deliverd-route';
export const today_missed = 'driver/driver-missed-list';
export const driver_submit_consent = 'driver/submit-consent';

export const driver_all_pharmacy_list = 'driver/all-pharmacy-list';
export const driver_get_Pharmacy = 'driver/get-Pharmacy'
export const driver_digital_id_card = 'driver/digital-id-card'
export const driver_digital_id_card_save_photo = 'driver/digital-id-card/save-photo'
export const driver_authorization_letter = 'driver/authorization-letter'
export const driver_today_appointment_deliveries = 'driver/today-appointment-deliveries'
export const driver_clinic_calls = 'driver/clinic-calls'

export const driver_SOS_emergency = 'driver/sos-emergency'

export const driver_supervisor_analytics = 'driver/supervisor-analytics'
export const driver_patient_newrx = 'driver/patient-newrx'
export const update_newrx_option = 'driver/update-newrx-option'
export const patient_prescription = 'driver/patient-prescription'
export const patient_without_pharmacist_sign = 'driver/patient-without-pharmacist-sign'

export const save_pharmasist_sign = 'driver/save-pharmasist-sign'
export const update_patient_profile = 'driver/update-patient-profile'

export const set_temp_driver_pharmacist = 'driver/set-temp-driver-pharmacist'

export const is_return_validate = 'driver/is-return-validate'

export const upload_triplicates_patient_sign = 'driver/upload-triplicates-patient-sign'

export const who_viewed_med = 'driver/view-patients-create-log';

export const search_patient = 'driver/search-consent-patient'
export const otp_verification = 'driver/submit-otp'

export const driver_get_recent_chats = 'driver/chat/dp-get-recent-chats'
export const driver_chat_users = 'driver/chat/chat-users'

export const driver_chat_initated = 'driver/chat/initiate-driver-chat'
export const driver_add_message_to_group = 'driver/chat/add-message-driver-chat'

export const pharmacy_read_messages = 'driver/chat/dp-read-messages'
export const driver_update_tu_online_status = 'driver/chat/driver-update-tu-online-status'

export const pending_counselling = 'driver/consult/pending-patients'
export const pending_counselling_counts = 'driver/consult/pending-count'
export const update_status = 'driver/consult/update-status'

export const driver_default_pharmacist = 'driver/pharmacist-list-of-pharmacy'
export const save_pharmacist_for_driver = 'driver/save-pharmacist-for-driver'
export const pharmacy_has_linked_otp = 'driver/pharmacy-has-linked-otp'
export const check_unassigned_vital_patients = 'driver/check-unassigned-vital-patients'

export const flexi_refills = 'driver/flexi-refills'
export const driver_missed_verifications = 'driver/missed-verifications'
export const get_missed_rx3x4x = 'driver/get-missed-rx3x4x'
export const driver_emergency_prepared_rx = 'driver/emergency-prepared-rx'
export const driver_vital_patients = 'driver/vital-patients'
export const driver_save_patient_vitals = 'driver/save-patient-vitals'

// Video Call Channels
export const videoCallChannelName = 'video-call-channel'
export const initiate_video_call_to_pharmacist = 'driver/initiate-video-call-to-pharmacist'
export const save_delivery_call_image = 'driver/save-delivery-call-image'
export const driver_delivery_video_calls = 'driver/delivery-video-calls'
export const driver_delivery_video_call_cancel = 'driver/delivery-video-calls'
export const driver_delivery_video_call_end = 'driver/delivery-video-calls'
export const driver_delivery_video_call_pharmacist_end = 'driver/delivery-video-calls'
export const driver_pharmacist_driver_video_calls = 'driver/pharmacist-driver-video-calls'
export const driver_pharmacist_driver_video_call_initiate = 'driver/pharmacist-driver-video-call/initiate'
export const driver_pharmacy_driver_list = 'driver/pharmacy-driver'

// Push Notification API Endpoints
export const save_push_subscription = 'driver/push-notification/save-subscription'
export const save_fcm_token = 'driver/push-notification/save-fcm-token'
export const get_vapid_public_key = 'driver/push-notification/vapid-public-key'



